<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>LR Receipt - Siby Logistics</title>
    <style>
        @page {
            size: A4 landscape;
            margin: 0;
        }
        body {
            font-family: Arial, Helvetica, sans-serif;
            margin: 0;
            padding: 5mm;
            box-sizing: border-box;
            font-size: 14px;
            /* Base font size adjusted for A4 */
            line-height: 1.25;
            width: 297mm;
            height: 210mm;
            /* Ensure it looks right on screen too if max-width is constrained, 
                but for print we want exact inches usually. 
                A5 Landscape is approx 210mm width. */
        }
        * {
            box-sizing: border-box;
        }
        .container {
            width: 100%;
            height: 100%;
            border: 2px solid black;
            padding: 5px;
            display: flex;
            flex-direction: column;
        }
        /* Helpers */
        .text-center {
            text-align: center;
        }
        .text-right {
            text-align: right;
        }
        .bold {
            font-weight: bold;
        }
        .flex {
            display: flex;
        }
        .row {
            display: flex;
            flex-direction: row;
        }
        .col {
            display: flex;
            flex-direction: column;
        }
        .border {
            border: 1px solid black;
        }
        .border-bottom {
            border-bottom: 1px solid black;
        }
        .border-right {
            border-right: 1px solid black;
        }
        .w-100 {
            width: 100%;
        }
        .m-0 {
            margin: 0;
        }
        /* Header */
        header {
            margin-bottom: 15px;
            position: relative;
        }
        h1 {
            font-size: 24px;
            margin: 0;
            text-transform: uppercase;
        }
        .address-line {
            font-size: 12px;
            margin-top: 2px;
        }
        .head-info {
            font-size: 11px;
            position: absolute;
            top: 0;
            right: 0;
            text-align: right;
        }
        /* Grid Layout for Top Section */
        .top-grid {
            display: grid;
            grid-template-columns: 1.1fr 1.1fr 0.8fr;
            gap: 5px;
            margin-bottom: 15px;
        }
        /* Sections specific styles */
        .caution-box {
            font-size: 11px;
            text-align: center;
        }
        .caution-text {
            margin-bottom: 3px;
        }
        .box-header {
            font-weight: bold;
            background: #fff;
            padding: 2px;
            border-bottom: 1px solid black;
            text-align: center;
        }
        .input-row {
            display: flex;
            padding: 2px;
        }
        .input-label {
            white-space: nowrap;
            margin-right: 5px;
        }
        .input-line {
            flex-grow: 1;
            border-bottom: 1px solid black;
        }
        /* Consignee Copy Center Box */
        .center-box {
            border: 1px solid black;
        }
        .center-box .row-item {
            border-bottom: 1px solid black;
            padding: 2px;
            text-align: center;
            font-weight: bold;
        }
        .insurance-section {
            padding: 2px;
            font-size: 11px;
        }
        /* Right Box */
        .right-box {}
        .gst-box {
            border: 1px solid black;
            height: 40px;
            margin-bottom: 5px;
            text-align: center;
            font-weight: bold;
            padding-top: 5px;
        }
        /* Middle Forms (Consignor/Consignee) */
        .middle-forms {
            margin-bottom: 15px;
        }
        .form-line {
            display: flex;
            align-items: flex-end;
            margin-bottom: 2px;
            font-size: 12px;
        }
        .form-line label {
            white-space: nowrap;
            margin-right: 5px;
            min-width: 160px;
        }
        .form-line.short-label label {
            min-width: auto;
        }
        .dotted-line {
            flex-grow: 1;
            border-bottom: 1px solid black;
            height: 20px;
        }
        /* Table */
        .main-table {
            width: 100%;
            border-collapse: collapse;
            font-size: 12px;
            margin-bottom: 15px;
        }
        .main-table th,
        .main-table td {
            border: 1px solid black;
            padding: 2px;
            text-align: center;
            vertical-align: middle;
            height: 30px;
            /* Minimum row height */
        }
        .main-table th {
            font-weight: bold;
        }
        .col-desc {
            width: 40%;
            text-align: left;
        }
        .col-pkg {
            width: 10%;
        }
        .col-weight {
            width: 10%;
        }
        /* Footer */
        .footer {
            margin-top: auto;
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
            font-size: 12px;
        }
    </style>
</head>
<body>
    <div class="container">
        <header class="text-center">
            <h1>Siby Logistics Private Limited</h1>
            <div class="address-line">Registered Office: 104, Sirisampada Hitech, Madhapur, Hyderabad - 500081,
                Telangana, India.</div>
            <div class="head-info">
                Head Office: 040 31548838<br>
                93256 47215<br>
                GSTIN: 36ABJCS0167M1ZX
            </div>
        </header>
        <div class="top-grid">
            <!-- Loop 1: Caution & Note -->
            <div class="col">
                <div class="caution-box">
                    <div class="bold">CAUTION</div>
                    <div class="caution-text">
                        The Consignment will not be detained/ diverted/ re-routed
                        or re-booked without Consignee Bank's written
                        permission. It will be delivery at the destination.
                    </div>
                </div>
                <div class="border" style="margin-bottom: 3px;">
                    <div class="box-header">Address of Delivery Office</div>
                    <div style="height: 40px;"></div>
                </div>
                <div class="border">
                    <div class="box-header">CONSIGNMENT NOTE</div>
                    <div class="input-row border-bottom" style="padding-left: 10px;">
                        <span class="input-label">No.:</span>
                        <!-- <div class="input-line"></div> -->
                    </div>
                    <div class="input-row" style="padding-left: 10px;">
                        <span class="input-label">Date:</span>
                        <!-- <div class="input-line"></div> -->
                    </div>
                </div>
            </div>
            <!-- Loop 2: Consignee Copy / Insurance -->
            <div class="col center-box">
                <div class="row-item">CONSIGNEE COPY</div>
                <div class="row-item">AT OWNER'S RISK</div>
                <div class="row-item">INSURANCE</div>
                <div class="insurance-section">
                    The Customer has stated that:<br>
                    He has not insured the consignment<br>
                    <div class="text-center">OR</div>
                    He has insured the consignment<br>
                    <br>
                    Company: <span
                        style="border-bottom: 1px solid black; display: inline-block; width: 60%;"></span><br>
                    <div style="display: flex; margin-top: 2px;">
                        Policy No.: <span
                            style="border-bottom: 1px solid black; flex-grow: 1; margin-right: 5px;"></span>
                        Date: <span style="border-bottom: 1px solid black; width: 60px;"></span>
                    </div>
                    <div style="display: flex; margin-top: 2px;">
                        Amount: <span style="border-bottom: 1px solid black; flex-grow: 1; margin-right: 5px;"></span>
                        Risk: <span style="border-bottom: 1px solid black; width: 60px;"></span>
                    </div>
                </div>
            </div>
            <!-- Loop 3: GST & Vehicle Info -->
            <div class="col right-box">
                <div class="gst-box">
                    GST PAYABLE BY
                </div>
                <div style="font-size: 12px;">
                    <div style="display: flex; margin-top: 14px; align-items: flex-end;">
                        <span style="font-weight: bold; margin-right: 2px;">Vehicle No.:</span>
                        <div style="border-bottom: 1px solid black; flex-grow: 1;"></div>
                    </div>
                    <div style="display: flex; margin-top: 14px; align-items: flex-end;">
                        <span style="font-weight: bold; margin-right: 2px;">E Way Bill No.:</span>
                        <div style="border-bottom: 1px solid black; flex-grow: 1;"></div>
                    </div>
                    <div style="display: flex; margin-top: 14px; align-items: flex-end;">
                        <span style="font-weight: bold; margin-right: 2px;">Eway Bill Date:</span>
                        <div style="border-bottom: 1px solid black; flex-grow: 1;"></div>
                    </div>
                    <div style="display: flex; margin-top: 14px; align-items: flex-end;">
                        <span style="font-weight: bold; margin-right: 2px;">Invoice No.:</span>
                        <div style="border-bottom: 1px solid black; flex-grow: 1;"></div>
                    </div>
                    <div style="display: flex; margin-top: 14px; align-items: flex-end;">
                        <span style="font-weight: bold; margin-right: 2px;">Invoice Date:</span>
                        <div style="border-bottom: 1px solid black; flex-grow: 1;"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="middle-forms">
            <!-- Consignor Row -->
            <div class="top-grid m-0" style="margin-bottom: 2px;">
                <div class="col" style="grid-column: span 2; padding-right: 10px;">
                    <!-- Row 1 -->
                    <div class="form-line m-0">
                        <label style="min-width: 180px;">Consignor's Name & Address</label>
                        <div class="dotted-line"></div>
                    </div>
                    <!-- Row 2 -->
                    <div class="form-line m-0">
                        <div class="dotted-line"></div>
                    </div>
                    <!-- Row 3 -->
                    <div class="form-line m-0">
                        <div class="dotted-line"></div>
                        <div style="margin-left: 5px; margin-right: 5px; white-space: nowrap;">GST No.:</div>
                        <div class="dotted-line" style="width: 120px; flex-grow: 0;"></div>
                    </div>
                </div>
                <div class="col">
                    <div style="font-size: 12px;">From :</div>
                    <div class="border" style="width: 100%; height: 50px; margin-top: 2px;"></div>
                </div>
            </div>
            <!-- Consignee Row -->
            <div class="top-grid m-0">
                <div class="col" style="grid-column: span 2; padding-right: 10px;">
                    <!-- Row 1 -->
                    <div class="form-line m-0">
                        <label style="min-width: 180px;">Consignee Name & Address</label>
                        <div class="dotted-line"></div>
                    </div>
                    <!-- Row 2 -->
                    <div class="form-line m-0">
                        <div class="dotted-line"></div>
                    </div>
                    <!-- Row 3 -->
                    <div class="form-line m-0">
                        <div class="dotted-line"></div>
                        <div style="margin-left: 5px; margin-right: 5px; white-space: nowrap;">GST No.:</div>
                        <div class="dotted-line" style="width: 120px; flex-grow: 0;"></div>
                    </div>
                </div>
                <div class="col">
                    <div style="font-size: 12px;">To :</div>
                    <div class="border" style="width: 100%; height: 50px; margin-top: 2px;"></div>
                </div>
            </div>
        </div>
        <table class="main-table">
            <thead>
                <tr>
                    <th rowspan="2" class="col-pkg">Package</th>
                    <th rowspan="2">Description (Said to Contain)</th>
                    <th colspan="2">(Weight SWA)</th>
                    <th rowspan="2" style="width: 10%;">Rate per MT</th>
                    <th colspan="2" style="width: 15%;">Amount (Rs.)</th>
                </tr>
                <tr>
                    <th class="col-weight">Actual</th>
                    <th class="col-weight">Charged</th>
                    <th style="width: 10%;">Rs.</th>
                    <th style="width: 5%;">P.</th>
                </tr>
            </thead>
            <tbody>
                <!-- Row 1: Freight -->
                <tr>
                    <td rowspan="4"></td>
                    <td rowspan="4"></td>
                    <td rowspan="4"></td>
                    <td rowspan="4"></td>
                    <td style="font-weight: bold;">Freight</td>
                    <td></td>
                    <td></td>
                </tr>
                <!-- Row 2: St. Ch. -->
                <tr>
                    <td style="font-weight: bold;">St. Ch.</td>
                    <td></td>
                    <td></td>
                </tr>
                <!-- Row 3: Blank/Other -->
                <tr>
                    <td>&nbsp;</td>
                    <td></td>
                    <td></td>
                </tr>
                <!-- Row 4: Total -->
                <tr>
                    <td style="font-weight: bold; text-align: center;">TOTAL</td> <!-- Rate Column -->
                    <td style="font-weight: bold;"></td>
                    <td style="font-weight: bold;"></td>
                </tr>
            </tbody>
        </table>
        <div class="footer">
            <div>
                Carrier's is not responsible for Leakages & Breakages.<br>
                <div style="display: flex; margin-top: 5px; align-items: flex-end;">
                    Value: <div style="border-bottom: 1px solid black; width: 220px; margin-left: 5px;"></div>
                </div>
            </div>
            <div style="text-align: right;">
                For <b>SIBY LOGISTICS PRIVATE LIMITED</b>
                <div style="margin-top: 15px; display: flex; align-items: flex-end;">
                    Signature of the Transport Operator
                    <div style="border-bottom: 1px solid black; width: 220px; margin-left: 5px;"></div>
                </div>
            </div>
        </div>
    </div>
</body>
</html>